import { CascadiaJsonFormContext } from "@certn/forms";
import { ArrayControlProps } from "@jsonforms/core";
import { withJsonFormsArrayControlProps } from "@jsonforms/react";
import { useContext } from "react";

import { IdentityDocumentFilesControl } from "./IdentityDocumentFilesControl";
import { IdentityDocumentFilesSummaryControl } from "./IdentityDocumentFilesSummaryControl";

function IdentityDocumentFilesControlWrapper(props: ArrayControlProps) {
  const { isSummary } = useContext(CascadiaJsonFormContext);

  if (isSummary) {
    return <IdentityDocumentFilesSummaryControl {...props} />;
  }

  return <IdentityDocumentFilesControl {...props} />;
}

export const IdentityDocumentFilesControlRenderer =
  withJsonFormsArrayControlProps(IdentityDocumentFilesControlWrapper);
